import App from "./App.js";
import Map from "./components/Map.js";
import React from "react";
import ReactDOM from "react-dom/client";

ReactDOM.createRoot(document.querySelector("#root")).render(<App />);
